import { ContextType, useContext } from "react";

import { SessionStoreContext } from "../contexts/sessionStore";

export function useSessionStore(): ContextType<typeof SessionStoreContext> {
  return useContext(SessionStoreContext);
}
